module.exports = __webpack_public_path__ + "img/33600.bf810c4c.jpg";